import React from 'react';
import PropTypes from 'prop-types';

import { SAVINGS_MONTHLY_BALANCES } from '@ratehub/inv-common';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import HeadingPropTypes from '../definitions/HeadingPropTypes';
import SavingsAccountPropType from '../definitions/SavingsAccountPropType';
import HeadingBlock from './HeadingBlock';
import ProductCardLayoutSavings from './ProductCardLayoutSavings';


function ProductSingleSavings({
    heading,
    savingsAccount,
    monthlyBalance = SAVINGS_MONTHLY_BALANCES[1],    // $5,000
    ...otherProps
}) {
    return (
        // If slot is nullish (usually because the product is deprecated), don't render anything.
        // This is to ensure legacy pages with deprecated products don't prevent exporter from running.
        <If condition={savingsAccount} >
            <div {...otherProps}>
                <If condition={heading}>
                    <HeadingBlock
                        {...heading}
                    />
                </If>

                <ProductCardLayoutSavings
                    savingsAccount={savingsAccount}
                    monthlyBalance={monthlyBalance}
                />
            </div>
        </If>
    );
}

ProductSingleSavings.propTypes = {
    heading: HeadingPropTypes,
    savingsAccount: SavingsAccountPropType,
    monthlyBalance: PropTypes.number,
};


ProductSingleSavings.blockKey = 'rh/product-single-savings';
ProductSingleSavings.hasHeading = true;
ProductSingleSavings.requiresLayoutRow = true;
ProductSingleSavings.supportedPageTypes = [ PAGE_TEMPLATES.savings ];


export default ProductSingleSavings;
